import styles from "./FilterContainer.module.css"
import CloseSquareIcon from "@assets/icons/closeSquare"
import FilterItem from "./FilterItem"

const FilterContainer = ({
  setShowFilters,
  filterToBeExpanded,
  setFilterToBeExpanded,
  setPaginationState,
  paginationState,
  filters,
  title = "Filter",
  valueTransformFunctions = {},
}) => {
  const filtersCloseIconClickHandler = () => {
    setShowFilters(false)
    setFilterToBeExpanded(null)
  }

  const clearFilters = () => {
    setPaginationState((previous) => {
      // Keep only pagination related properties
      return { page: previous.page, limit: previous.limit }
    })
  }

  const getItemsSelected = () => {
    let count = 0
    Object.entries(paginationState).forEach(([key, value]) => {
      if (
        key !== "limit" &&
        key !== "page" &&
        key !== "sortBy" &&
        key !== "order"
      ) {
        if (value !== "") {
          count++
        }
      }
    })
    return count
  }

  return (
    <div className={styles.filterSection} onClick={(e) => e.stopPropagation()}>
      <div className={styles.filtersWrapper}>
        <div className={styles.header}>
          <div className={styles.headingAndActions}>
            <h2 className={styles.heading}>{title}</h2>
            <div className={styles.filtersRemoveActions}>
              {Object.keys(paginationState).length > 2 ? (
                <button
                  onClick={clearFilters}
                  className="px-2 py-2 rounded-lg bg-[--primary-blue-light] text-xs text-[#061C3D]"
                >
                  Remove filters
                </button>
              ) : null}
              <button onClick={filtersCloseIconClickHandler}>
                <CloseSquareIcon />
              </button>
            </div>
          </div>

          <div className={styles.itemsSelectedCount}>
            item Selected - {getItemsSelected()}
          </div>
        </div>

        {filters.map((filter) => (
          <FilterItem
            key={filter.filterProperty}
            filterName={filter.filterName}
            filterProperty={filter.filterProperty}
            filterPath={filter.filterPath}
            filterToBeExpanded={filterToBeExpanded}
            setPaginationState={setPaginationState}
            paginationState={paginationState}
            valueTransformFunction={
              valueTransformFunctions[filter.filterProperty]
            }
            dataSource={filter.dataSource}
          />
        ))}
      </div>
    </div>
  )
}

export default FilterContainer
